import { render, staticRenderFns } from "./CheckeredFlagIcon.vue?vue&type=template&id=31051436&scoped=true"
import script from "./CheckeredFlagIcon.vue?vue&type=script&lang=js"
export * from "./CheckeredFlagIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31051436",
  null
  
)

export default component.exports